import Base from './base'

function transform(list) {
  var results = {};
  var code;
  for (var i = 0; i < list.length; i++) {
    code = list[i].materialProductCode || list[i].materialPartNumber;
    if (!results[code]) {
      results[code] = {
        productCode: list[i].materialProductCode || list[i].materialPartNumber,
        description: list[i].description || list[i].materialDescription,
        colors: []
      };
    }

    if (list[i].UTV) {
      results[code].hasUTV = true;
    }

    results[code].colors.push(list[i]);
  }
  return results;
}

export default {
  trims () {
    return Base
      .get('/webmaterialscolorsview/all')
      .then(res => res.data)
      .then(transform)
  },
  inserts () {
    return Base
      .get('/webinsertmaterialscolorsview/all')
      .then(res => res.data)
      .then(transform)
  }

}
